import React from 'react';
import PropTypes from 'prop-types';
import {reactLocalStorage} from 'reactjs-localstorage';
import config from '../config';

const Subscription = () => {
    const allowUser = (data, uid) => {
        if (data.status === 'success' && data.subStatus === 'active') {
            let date = new Date();
            let subDate = new Date(data.endDate);
            let currentTime = date.getTime();
            let subTime = subDate.getTime();
            console.log('>>> currentTime && subTime ::', subDate, currentTime, subTime);
            if (currentTime > subTime) {
                window.location.href = config.get('base') + config.get('login');
            } else {
                reactLocalStorage.setObject('subcription', data);
            }
        } else {
            window.location.href = config.get('base') + config.get('login');
        }
    };
    const checkSubcription = (uid) => {
        const apiChecksub = config.get('base') + config.get('checkSub')
        fetch(apiChecksub, {
            method: 'POST',
            headers: config.get('headers'),
                body: JSON.stringify({uid: uid})
            })
            .then(response => response.json())
            .then(data => {
                console.log('checkSubcription data ::', data, uid);
                allowUser(data, uid);
            })
            .catch((error) => {
                console.error('step 1.1 :: Error:', error);
            });
    };
    return {allowUser, checkSubcription};
};

Subscription.propTypes = {
    
};

export default Subscription;